import { render } from "./tileserver-config-editor.vue?vue&type=template&id=685e573e&scoped=true"
import script from "./tileserver-config-editor.vue?vue&type=script&lang=ts"
export * from "./tileserver-config-editor.vue?vue&type=script&lang=ts"

import "./tileserver-config-editor.vue?vue&type=style&index=0&id=685e573e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-685e573e"

export default script